import ShellHeader from '../components/ShellHeader';

function PartExchangePage({ authUser }) {
  return (
    <div className="site-shell">
      <ShellHeader authUser={authUser} />

      <main className="content-wrap content-wrap-single">
        <section className="content-page-block part-exchange-block">
          <div className="section-header">
            <h2>Part Exchange</h2>
          </div>

          <p>
            Our dedicated team of vehicle valuation experts are ready to give you an
            up-to-the-minute market value of your car.
          </p>

          <h3 className="part-exchange-subheading">Free Quote</h3>

          <p>
            If you are considering part exchanging your current vehicle we are able to provide
            you with a free, no-obligation quote.
          </p>

          <p>
            Please contact one of our Sales Consultants on{' '}
            <a className="part-exchange-phone" href="tel:01782835561">01782 835 561</a>
          </p>
        </section>
      </main>
    </div>
  );
}

export default PartExchangePage;
